/**
 * The (well-known) tenant id for the Microsoft tenant. Users signed
 * in with MS, linkedin, etc corp accounts will have this listed on
 * their user/profile/me data as the tenant id or TID.
 */
export const MICROSOFT_TENANT_ID = '72f988bf-86f1-41af-91ab-2d7cd011db47';
